import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _get from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/get.js";
import _classPrivateFieldGet from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// import from provider.ts instead of index.ts to prevent circular dep
// from EtherscanProvider
import { Log, TransactionReceipt, TransactionResponse } from "../providers/provider.js";
import { defineProperties, EventPayload } from "../utils/index.js";
/**
 *  An **EventLog** contains additional properties parsed from the [[Log]].
 */
export var EventLog = /*#__PURE__*/function (_Log) {
  _inherits(EventLog, _Log);
  var _super = _createSuper(EventLog);
  /**
   *  The Contract Interface.
   */

  /**
   *  The matching event.
   */

  /**
   *  The parsed arguments passed to the event by ``emit``.
   */

  /**
   * @_ignore:
   */
  function EventLog(log, iface, fragment) {
    var _this;
    _classCallCheck(this, EventLog);
    _this = _super.call(this, log, log.provider);
    _defineProperty(_assertThisInitialized(_this), "interface", void 0);
    _defineProperty(_assertThisInitialized(_this), "fragment", void 0);
    _defineProperty(_assertThisInitialized(_this), "args", void 0);
    var args = iface.decodeEventLog(fragment, log.data, log.topics);
    defineProperties(_assertThisInitialized(_this), {
      args: args,
      fragment: fragment,
      interface: iface
    });
    return _this;
  }
  /**
   *  The name of the event.
   */
  _createClass(EventLog, [{
    key: "eventName",
    get: function get() {
      return this.fragment.name;
    }
    /**
     *  The signature of the event.
     */
  }, {
    key: "eventSignature",
    get: function get() {
      return this.fragment.format();
    }
  }]);
  return EventLog;
}(Log);
/**
 *  A **ContractTransactionReceipt** includes the parsed logs from a
 *  [[TransactionReceipt]].
 */
var _iface = /*#__PURE__*/new WeakMap();
export var ContractTransactionReceipt = /*#__PURE__*/function (_TransactionReceipt) {
  _inherits(ContractTransactionReceipt, _TransactionReceipt);
  var _super2 = _createSuper(ContractTransactionReceipt);
  /**
   *  @_ignore:
   */
  function ContractTransactionReceipt(iface, provider, tx) {
    var _this2;
    _classCallCheck(this, ContractTransactionReceipt);
    _this2 = _super2.call(this, tx, provider);
    _classPrivateFieldInitSpec(_assertThisInitialized(_this2), _iface, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldSet(_assertThisInitialized(_this2), _iface, iface);
    return _this2;
  }
  /**
   *  The parsed logs for any [[Log]] which has a matching event in the
   *  Contract ABI.
   */
  _createClass(ContractTransactionReceipt, [{
    key: "logs",
    get: function get() {
      var _this3 = this;
      return _get(_getPrototypeOf(ContractTransactionReceipt.prototype), "logs", this).map(function (log) {
        var fragment = log.topics.length ? _classPrivateFieldGet(_this3, _iface).getEvent(log.topics[0]) : null;
        if (fragment) {
          return new EventLog(log, _classPrivateFieldGet(_this3, _iface), fragment);
        } else {
          return log;
        }
      });
    }
  }]);
  return ContractTransactionReceipt;
}(TransactionReceipt);
/**
 *  A **ContractTransactionResponse** will return a
 *  [[ContractTransactionReceipt]] when waited on.
 */
var _iface2 = /*#__PURE__*/new WeakMap();
export var ContractTransactionResponse = /*#__PURE__*/function (_TransactionResponse) {
  _inherits(ContractTransactionResponse, _TransactionResponse);
  var _super3 = _createSuper(ContractTransactionResponse);
  /**
   *  @_ignore:
   */
  function ContractTransactionResponse(iface, provider, tx) {
    var _this4;
    _classCallCheck(this, ContractTransactionResponse);
    _this4 = _super3.call(this, tx, provider);
    _classPrivateFieldInitSpec(_assertThisInitialized(_this4), _iface2, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldSet(_assertThisInitialized(_this4), _iface2, iface);
    return _this4;
  }
  /**
   *  Resolves once this transaction has been mined and has
   *  %%confirms%% blocks including it (default: ``1``) with an
   *  optional %%timeout%%.
   *
   *  This can resolve to ``null`` only if %%confirms%% is ``0``
   *  and the transaction has not been mined, otherwise this will
   *  wait until enough confirmations have completed.
   */
  _createClass(ContractTransactionResponse, [{
    key: "wait",
    value: function () {
      var _wait = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(confirms) {
        var receipt;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _get(_getPrototypeOf(ContractTransactionResponse.prototype), "wait", this).call(this);
            case 2:
              receipt = _context.sent;
              if (!(receipt == null)) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return", null);
            case 5:
              return _context.abrupt("return", new ContractTransactionReceipt(_classPrivateFieldGet(this, _iface2), this.provider, receipt));
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function wait(_x) {
        return _wait.apply(this, arguments);
      }
      return wait;
    }()
  }]);
  return ContractTransactionResponse;
}(TransactionResponse);
/**
 *  A **ContractUnknownEventPayload** is included as the last parameter to
 *  Contract Events when the event does not match any events in the ABI.
 */
export var ContractUnknownEventPayload = /*#__PURE__*/function (_EventPayload) {
  _inherits(ContractUnknownEventPayload, _EventPayload);
  var _super4 = _createSuper(ContractUnknownEventPayload);
  /**
   *  The log with no matching events.
   */

  /**
   *  @_event:
   */
  function ContractUnknownEventPayload(contract, listener, filter, log) {
    var _this5;
    _classCallCheck(this, ContractUnknownEventPayload);
    _this5 = _super4.call(this, contract, listener, filter);
    _defineProperty(_assertThisInitialized(_this5), "log", void 0);
    defineProperties(_assertThisInitialized(_this5), {
      log: log
    });
    return _this5;
  }
  /**
   *  Resolves to the block the event occured in.
   */
  _createClass(ContractUnknownEventPayload, [{
    key: "getBlock",
    value: function () {
      var _getBlock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.log.getBlock();
            case 2:
              return _context2.abrupt("return", _context2.sent);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getBlock() {
        return _getBlock.apply(this, arguments);
      }
      return getBlock;
    }()
    /**
     *  Resolves to the transaction the event occured in.
     */
  }, {
    key: "getTransaction",
    value: function () {
      var _getTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.log.getTransaction();
            case 2:
              return _context3.abrupt("return", _context3.sent);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getTransaction() {
        return _getTransaction.apply(this, arguments);
      }
      return getTransaction;
    }()
    /**
     *  Resolves to the transaction receipt the event occured in.
     */
  }, {
    key: "getTransactionReceipt",
    value: function () {
      var _getTransactionReceipt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.log.getTransactionReceipt();
            case 2:
              return _context4.abrupt("return", _context4.sent);
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getTransactionReceipt() {
        return _getTransactionReceipt.apply(this, arguments);
      }
      return getTransactionReceipt;
    }()
  }]);
  return ContractUnknownEventPayload;
}(EventPayload);
/**
 *  A **ContractEventPayload** is included as the last parameter to
 *  Contract Events when the event is known.
 */
export var ContractEventPayload = /*#__PURE__*/function (_ContractUnknownEvent) {
  _inherits(ContractEventPayload, _ContractUnknownEvent);
  var _super5 = _createSuper(ContractEventPayload);
  /**
   *  @_ignore:
   */
  function ContractEventPayload(contract, listener, filter, fragment, _log) {
    var _this6;
    _classCallCheck(this, ContractEventPayload);
    _this6 = _super5.call(this, contract, listener, filter, new EventLog(_log, contract.interface, fragment));
    var args = contract.interface.decodeEventLog(fragment, _this6.log.data, _this6.log.topics);
    defineProperties(_assertThisInitialized(_this6), {
      args: args,
      fragment: fragment
    });
    return _this6;
  }
  /**
   *  The event name.
   */
  _createClass(ContractEventPayload, [{
    key: "eventName",
    get: function get() {
      return this.fragment.name;
    }
    /**
     *  The event signature.
     */
  }, {
    key: "eventSignature",
    get: function get() {
      return this.fragment.format();
    }
  }]);
  return ContractEventPayload;
}(ContractUnknownEventPayload);